define('fukit/helpers/factory',['require','exports','module','underscore','backbone','uikit/uikit','marionette','appkit/util/key.prefixer','../behavior/resolve.options.behavior','../behavior/confirm.model.destroy.on.press.behavior','../behavior/enable.only.on.unsaved.changes.behavior','../behavior/enable.loading.on.model.request.behavior','../behavior/change.visibility.on.model.create.behavior','./extend.util','../behavior/authorization.behavior'],function(require, exports, module) {
  //prettier-ignore
  var _                                     = require('underscore'),
      Backbone                              = require('backbone'),
      UIKit                                 = require('uikit/uikit'),
      Mn                                    = require('marionette'),
      KeyPrefixer                           = require('appkit/util/key.prefixer'),
      ResolveOptionsBehavior                = require('../behavior/resolve.options.behavior'),
      ConfirmModelDestroyOnPressBehavior    = require('../behavior/confirm.model.destroy.on.press.behavior'),
      EnableOnlyOnUnsavedChangesBehavior    = require('../behavior/enable.only.on.unsaved.changes.behavior'),
      EnableLoadingOnModelRequestBehavior   = require('../behavior/enable.loading.on.model.request.behavior'),
      ChangeVisibilityOnModelCreateBehavior = require('../behavior/change.visibility.on.model.create.behavior'),
      ExtendUtil                            = require('./extend.util'),
      AuthorizationBehavior                 = require('../behavior/authorization.behavior');

  var factory = {
    /**
     * Creates a standard ellipsis column to be used on table columns
     * @param  {Object}  options  extend column with custom options
     * @return {Object}           ellipsis column
     */
    ellipsisColumn: function(options) {
      options || (options = {});
      var obj = {
        collapsing: true,
        childView: UIKit.TableEllipsis,
        childViewOptions: function(model) {
          return {
            collection: new Backbone.Collection([
              { text: 'Edit', icon: 'pencil', action: 'open' },
              {
                text: 'Delete',
                icon: 'trash',
                action: 'delete',
                behaviors: {
                  ConfirmModelDestroyOnPress: {
                    model: model,
                    behaviorClass: ConfirmModelDestroyOnPressBehavior,
                    modalOptions: options.destroyViewOptions || options.destroyModalOptions,
                  },
                },
              },
            ]),
          };
        },
        onBeforeAdd: function(view) {
          var dropdown = view.view;
        },
      };

      // extend object with optionss
      _.extend(obj, options);

      return obj;
    },

    /**
     * Creates a standard active toggle checkbox column to be used on table columns
     * @param  {Object} options extend column with custom options
     * @return {Object}         active column
     */
    activeColumn: function(options) {
      options = _.extend({}, options);

      var obj = {
        text: 'Active',
        collapsing: true,
        childView: UIKit.Checkbox.extend({
          behaviors: {
            AuthorizationBehavior: {
              enableOnlyWhen: options.enableOnlyWhen,
              visibleOnlyWhen: options.visibleOnlyWhen,
              setTextWhen: options.setTextWhen,
              behaviorClass: AuthorizationBehavior,
            },
          },
        }),
        childBindings: {
          value: 'active',
        },
        onBeforeAdd: function(view) {
          view.toggle = true;
          view.polar = true;
          view.$el.on('click', function(ev) {
            ev.stopPropagation();
          });
        },
      };

      // extend object with optionss
      _.extend(obj, options);

      return obj;
    },

    completedColumn: function(options) {
      return _.extend(
        {
          collapsing: true,
          childView: UIKit.ItemView.extend({
            template: false,
            className: 'icon',
            tagName: 'i',
            options: {
              completeIcon: 'check green',
              incompleteIcon: 'remove red',
              complete: false,
            },
            updateAttributes: function() {
              this.addClass(this.getOption('completeIcon'), this.getBoolOption('complete')).addClass(
                this.getOption('incompleteIcon'),
                !this.getBoolOption('complete')
              );
            },
          }),
        },
        options
      );
    },

    deleteButton: function(options) {
      return _.extend(
        {
          type: UIKit.Button,
          name: 'deleteButtonView',
          text: 'Delete',
          icon: 'trash',
          model: this.model,
          behaviors: {
            ChangeVisibilityOnModelCreate: {
              behaviorClass: ChangeVisibilityOnModelCreateBehavior,
            },
            ConfirmModelDestroyOnPress: {
              routeOnDestroyOptions: options.routeOnDestroyOptions,
              behaviorClass: ConfirmModelDestroyOnPressBehavior,
            },
            AuthorizationBehavior: {
              enableOnlyWhen: _.isArray(options.enableOnlyWhen) ? options.enableOnlyWhen : null,
              visibleOnlyWhen: _.isArray(options.visibleOnlyWhen) ? options.visibleOnlyWhen : null,
              setTextWhen: _.isArray(options.setTextWhen) ? options.setTextWhen : null,
              behaviorClass: AuthorizationBehavior,
            },
          },
        },
        options
      );
    },

    saveButton: function(options) {
      return _.extend(
        {
          type: UIKit.Button,
          name: 'saveButtonView',
          text: 'Save',
          icon: 'save',
          color: 'primary',
          behaviors: {
            EnableOnlyOnUnsavedChanges: {
              behaviorClass: EnableOnlyOnUnsavedChangesBehavior,
            },
            EnableLoadingOnModelRequest: {
              behaviorClass: EnableLoadingOnModelRequestBehavior,
            },
            AuthorizationBehavior: {
              enableOnlyWhen: _.isArray(options.enableOnlyWhen) ? options.enableOnlyWhen : null,
              visibleOnlyWhen: _.isArray(options.visibleOnlyWhen) ? options.visibleOnlyWhen : null,
              setTextWhen: _.isArray(options.setTextWhen) ? options.setTextWhen : null,
              behaviorClass: AuthorizationBehavior,
            },
          },
        },
        options
      );
    },

    createButton: function(options) {
      return _.extend(
        {
          type: UIKit.Button,
          name: 'createButtonView',
          text: 'Create',
          color: 'primary',
          icon: 'plus',
        },
        options
      );
    },

    cancelButton: function(options) {
      return _.extend(
        {
          type: UIKit.Button,
          name: 'cancelButtonView',
          text: 'Cancel',
          behaviors: {
            ChangeVisibilityOnModelCreate: {
              behaviorClass: ChangeVisibilityOnModelCreateBehavior,
              visibleWhenNew: true,
            },
          },
        },
        options
      );
    },

    // copied and kept for legacy support
    extendOptionValueWithDefaults: ExtendUtil.extendOptionValueWithDefaults,
  };

  module.exports = factory;
});

